import { defineLayoutModule } from '@databases/view-layout-modules';
import { z } from 'zod';

export const TABLE_LAYOUT_ID = 'table' as const;

export const TABLE_ROW_HEIGHTS = ['short', 'medium', 'tall', 'expanded'] as const;

export type TableRowHeight = (typeof TABLE_ROW_HEIGHTS)[number];

export const tableLayoutSchema = z.object({
  rowHeight: z.enum(TABLE_ROW_HEIGHTS).default('expanded')
});

export type TableLayoutSettings = z.infer<typeof tableLayoutSchema>;

export const DEFAULT_TABLE_LAYOUT_SETTINGS: TableLayoutSettings = tableLayoutSchema.parse(
  {}
);

/**
 * Registers typed settings for the built-in Table layout.
 *
 * Table is permanently supported, so this module uses the default `read-write`
 * mode. The row-height experiment controls its user-facing entry point without
 * coupling the entire Table settings namespace to one experimental property.
 */
export const tableViewLayoutModule = defineLayoutModule({
  id: TABLE_LAYOUT_ID,
  schema: tableLayoutSchema
});
